import config from '../app-config';
import bgImg from '../images/information-panel-background.svg';

const InformationSection = (props) => {
    return (
        <div className="row justify-content-center pt-20" id={props.id} style={{ backgroundImage: `url(${bgImg})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right bottom', backgroundSize: 'contain' }}>
            <div className="col-12 col-md-9 col-xl-7">
                <div className="well bg-transparent pt-10 pb-12">
                    <h1 className="text-uppercase text-center mb-6">{config.callToAction.titleExtendedText}</h1>
                    <h2 className="text-uppercase text-center mb-6">{config.callToAction.subTitleExtendedText}</h2>
                    <div>
                        {config.callToAction.extendedTextParagraphs.map(paragraph => (
                            <div key={paragraph.id}>
                                {paragraph.title != null && 
                                    <h4>{paragraph.title}</h4>
                                }
                                <p>{paragraph.text}</p>
                                {paragraph.highlightText != null && 
                                    <p><b>{paragraph.highlightText}</b></p>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InformationSection;
